export const ASAP_BOUNDARY_IN_MINUTES_FOR_THROTTLES = 30;
export const MINUTES_IN_ORDER_THROTTLE_WINDOW = 15;
